import React, { useState } from 'react';
import EyeIcon from './EyeIcon';

export default function EyeIconDetails({ DialogComponent, dialogProps = {}, ariaLabel, className, style }) {
  const [open, setOpen] = useState(false);

  if (!DialogComponent) {
    /* eslint-disable no-console */
    console.warn('EyeIconDetails: "DialogComponent" prop is required');
    /* eslint-enable no-console */
    return null;
  }

  return (
    <React.Fragment>
      <EyeIcon ariaLabel={ariaLabel} className={className} style={style} onClick={() => setOpen(true)} />
      {open && <DialogComponent {...dialogProps} onClose={() => setOpen(false)} />}
    </React.Fragment>
  );
}
